import { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

import IconHome from "../../../styles/icons/IconHome";
import { IBreadcrumb } from "../../../app/common-models/IBreadcrumb";
import {
  BreadCrumbGenerator,
  breadcrumbValuesHandle,
} from "../../../utils/helpers/helperMethods/BreadCumbGenerator";
import useUserRole from "../../../hooks/useUserRole";
import { UserRole } from "../../../utils";

const BREADCRUMB_COLOR = "#0f1560";
const bgColor = "#d9e2ef";

const BreadCrumb = () => {
  const location = useLocation();
  const currentUserRole = useUserRole();

  const getDashboardText = (role: UserRole) => {
    switch (role) {
      case UserRole.Operator:
        return "Call Console";

      default:
        return "Control Centre";
    }
  };
  const breadcrumbValues: IBreadcrumb[] = useMemo(
    () => BreadCrumbGenerator(location),
    [location]
  );

  return (
    <div className="breadcrumb-top">
      <Link className="list-styles" to="/">
        <div className="breadcrumb-section">
          <IconHome breadcrumb="workSpace" activeColor={BREADCRUMB_COLOR} />
          <span className="breadcrumb-value">
            {getDashboardText(currentUserRole)}
          </span>
        </div>
      </Link>

      {breadcrumbValues.map((breadcrumbValue, index) => {
        const to = breadcrumbValuesHandle(
          breadcrumbValue.name,
          breadcrumbValue.navigation,
          location
        );

        return (
          <Link
            className="list-styles"
            to={to}
            key={`${breadcrumbValue.url}-${breadcrumbValue.name}-${index}`}
          >
            <div className="breadcrumb-section">
              <span className="breadcrumb-icon-angle">
                <IconHome
                  breadcrumb="angleBracket"
                  activeColor={BREADCRUMB_COLOR}
                  bgColor={bgColor}
                />
              </span>

              <span className="breadcrumb-value">{breadcrumbValue.name}</span>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default BreadCrumb;
